import React, { Fragment } from 'react';
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import SplitCommon from '../Common/SplitCommon';
import ConversationSideBar from './ConversationSideBar';
import { getTemplatesFormDetails, loadFormData, populateFormDetails, prepareLabelNameMapper,getReferenceList,getAgentVoice, isMobile } from '../../Common/Appcommon';
import ConversationConfigTitle from './ConversationConfigTitle';
import ConversationConfig from './ConversationConfig';
import { Minimize } from '../Common/Minimize';
import Common from '../Common';
import { Container, Row } from 'reactstrap';

class Conversations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formDetails: [],
            templates: [],
            selectedTemplate: [],
            formData: [],
            listFields: [],
            page: 1,
            limit: 50,
            rowData: [],
            nameLabelMapper: {},
            sideBarLoader : false,
            mainLoader : false,
            adFilterSearch :"",
            agentDropDown : [],
            defaultAgentDropDown : {},
            callTCnt : 0,
            limitCount : 0,
            isAllowLoad:true,
            conLoader : false,
            isMinimized : false,
            AgentVoice: [],
            isMobileView: isMobile(),
            isDetailedView: false,
        }
    }

    componentDidMount = async () => {
        this.setState({
            sideBarLoader: true,
            mainLoader : true,
        });
        await this.fetchFormDetails();
        await this.fetchAgentLogs();
        let { selectedTemplate } = this.state;
        await this.fetchConversionLogs(selectedTemplate);
        this.setState({
            sideBarLoader: false,
            mainLoader : false,
        });
    };

    fetchFormDetails = async () => {
        let fDetail = await populateFormDetails("table_37");
        let { templates, selectedTemplate } = await getTemplatesFormDetails(fDetail,"Recently Created");
        this.setState({
            formDetails: fDetail,
            templates, selectedTemplate
        })
    };

    fetchConversionLogs = async (selectedTemplate) => {
        let { formDetails,adFilterSearch,limitCount,isAllowLoad } = this.state;
        if(isAllowLoad){
            let callData = await loadFormData("table_37", formDetails, selectedTemplate,"",adFilterSearch,true,[],"",limitCount);
            if (callData.issuccess) {
                let { formData, listFields,totalCount } = callData;
                const ids = formData.map(item => item.Agent_id);
                let nameLabelMapper = await prepareLabelNameMapper(formDetails[1]);
                let AgentVoice = await getAgentVoice();
                if(AgentVoice.issuccess){
                    AgentVoice = AgentVoice.data;
                }
                let rowData = formData[0];
                if(totalCount === formData.length){
                    isAllowLoad = false;   
                }
                this.setState({
                    formData, listFields, nameLabelMapper, rowData,callTCnt: totalCount,isAllowLoad,AgentVoice
                })
            }
        }
        this.setState({
            conLoader : false
        })
    }

    fetchAgentLogs = async () => {
        let {formDetails} = this.state;
        let fDetail = formDetails[1];

        let refDetail = fDetail.filter(record => record[2] === 'table_250_0_table_250_id')[0];
        if(refDetail && refDetail[35] !== undefined){
            let res =  await getReferenceList(refDetail[35]);
            if (res.issuccess) {
                let optionList   =  res.data;
                let dropDown = optionList[0];
                let allAgentsOption = { value: "All Agents", label: 'All Agents' };
                dropDown.unshift(allAgentsOption);
                this.setState ({
                    agentDropDown : dropDown,
                    defaultAgentDropDown : allAgentsOption,
                });
                
            }
        }
    }

    onTemplateChange = async (defaultAgentDropDownLst) => {
        let searchStr = defaultAgentDropDownLst.label.toLowerCase();
        let cond = "nondate@table_250_0@Agent_Name@is@"+searchStr+"@AND#"
        if(searchStr === "all agents"){
            cond = "";
        }
        let {selectedTemplate} = this.state;
        this.setState({ adFilterSearch : cond, defaultAgentDropDown :defaultAgentDropDownLst,isAllowLoad:true }, async () => {
            await this.fetchConversionLogs(selectedTemplate);
        });
        
    }

    loadMore = async (count) =>{
        let {selectedTemplate,limitCount } = this.state;
        count = limitCount + count;
        this.setState({ limitCount: count, conLoader: true}, async () => {
            await this.fetchConversionLogs(selectedTemplate);
        });
    }

    onCallLogClick = async (e, rowData, nameLabelMapper) => {
        this.setState({
            rowData, nameLabelMapper,
            isDetailedView: true,
        })
    }

    onHideSubMenu = () => {
        this.setState({
            isMinimized: !this.state.isMinimized
        });
    }

    goBackListView = () => {
        this.setState({
            isDetailedView: false,
        })
    }

    render() {
        let { formDetails, templates, selectedTemplate, isMinimized, formData, listFields, rowData, nameLabelMapper, sideBarLoader, mainLoader,agentDropDown,defaultAgentDropDown,callTCnt,conLoader,AgentVoice, isMobileView, isDetailedView } = this.state;
        if(isMobileView){
            if(isDetailedView){
                return (
                    <Fragment>
                        <Common
                            title="Calls"
                            titleContent={"Calls"}
                            titleBody={
                                <Row md={12}>
                                    <a className='cursor-pointer' onClick={(e) => { this.goBackListView() }}>
                                        <span className='d-flex align-center'>
                                            <i class="fi fi-br-arrow-left pr-1"></i>
                                            <span>Back</span>
                                        </span>
                                    </a>
                                </Row>
                            }
                            mainContent={
                                <ConversationConfig 
                                    rowData={rowData} 
                                    nameLabelMapper={nameLabelMapper} 
                                />
                            }
                        />
                    </Fragment>
                )
            }else{
                return (
                    <Fragment>
                        <Common
                            title="Calls"
                            titleContent={"Calls"}
                            mainContent={
                                <Fragment>
                                    {
                                        formDetails.length > 0 && 
                                        <ConversationSideBar
                                            formDetails={formDetails}
                                            searchTemplates={templates}
                                            selectedTemplate={selectedTemplate}
                                            data={formData}
                                            viewFields={listFields}
                                            onCallLogClick={this.onCallLogClick}
                                            nameLabelMapper={nameLabelMapper}
                                            onTemplateChange={this.onTemplateChange}
                                            agentDropDownList = {agentDropDown}
                                            defAgntDrpDwnLst = {defaultAgentDropDown}
                                            loadMoreData = {this.loadMore}
                                            conLoader = {conLoader}
                                            rowData = {rowData}
                                            AgentVoice = {AgentVoice}
                                        />
                                    }
                                </Fragment>
                            }
                        />
                    </Fragment>
                )
            }
        }
        if(isMinimized){
            return (
                <Fragment>
                    <Common
                        title="Calls"
                        isMinimized={isMinimized}
                        titleContent={
                            <>
                                <div className="app-header-left">
                                    {
                                        <Minimize 
                                            customClass={"conversation-headers"} 
                                            onHideSubMenu={this.onHideSubMenu}
                                            isMinimized={isMinimized}
                                        />
                                    }
                                    <div className="app-header-title">{<ConversationConfigTitle rowData={rowData} nameLabelMapper={nameLabelMapper} />}</div>
                                </div>
                            </>
                        }
                        titleBody={<></>}
                        mainContent={
                            <Fragment>
                                <ConversationConfig 
                                    rowData={rowData} 
                                    nameLabelMapper={nameLabelMapper} 
                                    mini={isMinimized}
                                />
                            </Fragment>
                        }
                    />
                </Fragment>
            )
        }
        return (
            <Fragment>
                <SplitCommon
                    mobileViewNeedLeftMenu = {true}
                    title={"Calls"}
                    sideBarLoader = {sideBarLoader}
                    mainLoader = {mainLoader}
                    sideBarTitleContent={<span>Calls<span class="count">{callTCnt}</span></span>}
                    mainTitleContent={    
                        <div className="app-header-right">
                            {
                                <Minimize 
                                    customClass={"conversation-headers"} 
                                    onHideSubMenu={this.onHideSubMenu}
                                    isMinimized={isMinimized}
                                />
                            }
                            <div className="app-header-title">{<ConversationConfigTitle rowData={rowData} nameLabelMapper={nameLabelMapper} />}</div>
                        </div>
                    }
                    sideBarContent={
                        <Fragment>
                            {formDetails.length > 0 && <ConversationSideBar
                                formDetails={formDetails}
                                searchTemplates={templates}
                                selectedTemplate={selectedTemplate}
                                data={formData}
                                viewFields={listFields}
                                onCallLogClick={this.onCallLogClick}
                                nameLabelMapper={nameLabelMapper}
                                onTemplateChange={this.onTemplateChange}
                                agentDropDownList = {agentDropDown}
                                defAgntDrpDwnLst = {defaultAgentDropDown}
                                loadMoreData = {this.loadMore}
                                conLoader = {conLoader}
                                rowData = {rowData}
                                AgentVoice = {AgentVoice}
                            />}
                        </Fragment>
                    } 
                    mainContent={
                        <ConversationConfig 
                            rowData={rowData} 
                            nameLabelMapper={nameLabelMapper} 
                        />
                    } />


            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Conversations);
